<template>
  <div class="w-30 mt-12px">
    <div class="half-graph-container">
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          border-bottom
          px-2
          pb-2
          pt-1
        "
      >
        <div class="dashboardAdmin-cards-head ml-2">
          Selection Rate Statistics
        </div>
      </div>
      <div
        class="
          job-alert-overflow
          d-flex
          flex-column
          align-items-center
          justify-content-center
        "
      >
        <div class="d-flex">
          <div class="gm-blue-txt">
            {{ showSelectionsRate.thisMonthPercentage }}%
          </div>
          <div class="ml-2 pt-1">
            <!-- CLASS - gm-green-percent -->
            <div
              class="d-flex align-items-start"
              :class="{
                'gm-green-percent': showSelectionsRate.difference > 0,
                'gm-red-percent': showSelectionsRate.difference < 0,
                'selection-grey-text': showSelectionsRate.difference === 0,
              }"
            >
              <div v-if="showSelectionsRate.difference != 0">
                {{ showSelectionsRate.difference }}%
              </div>
              <div v-else class="selection-grey-text">
                <img
                  class="mt-3 ml-1"
                  src="../../assets/New-imgs/landing-dashboard/greyLine.svg"
                  alt=""
                />
                <img
                  class="mt-3 ml-1"
                  src="../../assets/New-imgs/landing-dashboard/greypercent.svg"
                  alt=""
                />
              </div>
              <img
                v-if="showSelectionsRate.difference > 0"
                class="mt-1 ml-1"
                src="../../assets/New-imgs/landing-dashboard/greenUp.svg"
                alt=""
              />
              <img
                v-else-if="showSelectionsRate.difference < 0"
                class="mt-3 ml-1"
                src="../../assets/New-imgs/landing-dashboard/redDown.svg"
                alt=""
              />
              <img
                v-else-if="showSelectionsRate.difference == 0"
                class="mt-3 ml-1"
                src="../../assets/New-imgs/landing-dashboard/greyUp.svg"
                alt=""
              />
            </div>
            <!-- CLASS - gm-RED-small -->
            <div
              class="d-flex align-items-center pl-1"
              :class="{
                ' gm-green-small': showSelectionsRate.difference > 0,
                'gm-red-small': showSelectionsRate.difference < 0,
                'selection-grey-text': showSelectionsRate.difference === 0,
              }"
            >
              {{ showSelectionsRate.difference >= 0 ? "Increase" : "Decrease" }}
              <div
                v-b-tooltip.hover.bottomleft="'Compared from last month'"
                class="cs-greyshadow position-relative ml-2"
              >
                <img src="../../assets/customfield/greyI.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="gm-txt mt-4">Monthly Selection Rate</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSelectedRatio } from "../../utils/apiFunctions.js";
export default {
  props: {
    leadKey: Boolean,
  },
  data() {
    return {
      loopvar: 4,
      showTooltipLimit: false,
      showSelectionsRate: {},
    };
  },
  created() {
    this.getRatio();
  },
  methods: {
    async getRatio() {
      let payload = {
        lead: this.leadKey,
      };
      const res = await getSelectedRatio(payload);
      this.showSelectionsRate = res.data.data;

      this.showSelectionsRate.thisMonthPercentage = Number(
        res.data.data.thisMonthPercentage.toFixed(1)
      );
    },
  },
};
</script>

<style scoped>
.selection-grey-text {
  font-family: "Lato", sans-serif;
  font-size: 21.55px;
  font-weight: 500;
  color: #8c8c8c;
}
</style>
